export const support_role_endpoint = {
  tenant: "support/tenant",
  user: "support/users",
  company: "support/company",
};

export const endpoint = {
  vendor_category: "vendor_category",
  sap: "sap",
  officer: "officer",
  admin_vendor: "vendor",
  commodity_group: "commodity_group",
  sub_category: "sub_category",
  location_master: "location_master",
};
